
import { useEffect, useCallback, useState } from 'react';
import { observer } from 'mobx-react-lite';
import Stack from '@mui/joy/Stack';
import Divider from '@mui/joy/Divider';
import usePhone from '../hooks/usePhone';
import useClock from '../hooks/useClock';
import useUserIdentity from '../hooks/useUserIdentity';

import  CollabCallItem  from './CollabCallItem';

import { pluralize } from 'utils/misc';
const PhoneTopperCollabCallLog = observer(({ associated_type, associated_uuid }: { associated_type: string, associated_uuid: string }) => {
    const { fetchCallsByAssociation, getCallsByAssociation } = usePhone();
    const { currentClock } = useClock();
    const { currentIdentity } = useUserIdentity();
    const [loaded, setLoaded] = useState(false);

    const collabCalls = getCallsByAssociation(associated_type, associated_uuid);

    const loadCalls = useCallback(() => {
        if(currentClock?.associated_type == 'collab' && currentIdentity?.key) {
            fetchCallsByAssociation(associated_type, associated_uuid, currentIdentity?.key);
        }
    }, [currentClock?.associated_type,
        currentClock?.associated_uuid,
        currentIdentity?.key,
        fetchCallsByAssociation]);

    useEffect(() => {
        if(!loaded) {
            setLoaded(true)
            loadCalls();
        }
    }, [loadCalls, setLoaded, loaded]);

    return (
        <Stack>
                <Divider>This has { pluralize(collabCalls.length, 'existing call') }</Divider>


        <Stack
            spacing={1}
            divider={<Divider />} >


            { collabCalls.map((call) => (
                <CollabCallItem key={call.key} call={call} />
            )) }
        </Stack>
        </Stack>

    )
});

export default PhoneTopperCollabCallLog;
